export default "__VITE_ASSET__c1491adf__"